"use strict";

var _slicedToArray = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var validations_1 = require("../../utils/validations");

var ValidationError_1 = __importDefault(require("../../errors/ValidationError"));

var StreamMessage_1 = __importDefault(require("./StreamMessage"));

var GroupKeyMessage_1 = __importDefault(require("./GroupKeyMessage"));

var EncryptedGroupKey_1 = __importDefault(require("./EncryptedGroupKey"));

var GroupKeyResponse = /*#__PURE__*/function (_GroupKeyMessage_1$de) {
  _inherits(GroupKeyResponse, _GroupKeyMessage_1$de);

  var _super = _createSuper(GroupKeyResponse);

  function GroupKeyResponse(_ref) {
    var _this;

    var requestId = _ref.requestId,
        streamId = _ref.streamId,
        encryptedGroupKeys = _ref.encryptedGroupKeys;

    _classCallCheck(this, GroupKeyResponse);

    _this = _super.call(this, streamId, StreamMessage_1.default.MESSAGE_TYPES.GROUP_KEY_RESPONSE);
    validations_1.validateIsString('requestId', requestId);
    _this.requestId = requestId;
    validations_1.validateIsArray('encryptedGroupKeys', encryptedGroupKeys);
    _this.encryptedGroupKeys = encryptedGroupKeys; // Validate content of encryptedGroupKeys

    _this.encryptedGroupKeys.forEach(function (it) {
      if (!(it instanceof EncryptedGroupKey_1.default)) {
        throw new ValidationError_1.default("Expected 'encryptedGroupKeys' to be a list of EncryptedGroupKey instances! Was: ".concat(_this.encryptedGroupKeys));
      }
    });

    return _this;
  }

  _createClass(GroupKeyResponse, [{
    key: "toArray",
    value: function toArray() {
      return [this.requestId, this.streamId, this.encryptedGroupKeys.map(function (it) {
        return it.toArray();
      })];
    }
  }], [{
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr = _slicedToArray(arr, 3),
          requestId = _arr[0],
          streamId = _arr[1],
          encryptedGroupKeys = _arr[2];

      return new GroupKeyResponse({
        requestId: requestId,
        streamId: streamId,
        encryptedGroupKeys: encryptedGroupKeys.map(function (it) {
          return EncryptedGroupKey_1.default.fromArray(it);
        })
      });
    }
  }]);

  return GroupKeyResponse;
}(GroupKeyMessage_1.default);

exports.default = GroupKeyResponse;
GroupKeyMessage_1.default.classByMessageType[StreamMessage_1.default.MESSAGE_TYPES.GROUP_KEY_RESPONSE] = GroupKeyResponse;